import { IconButton, styled } from '@mui/material';

export const RoundedSquareIconButton = styled(IconButton)({
  borderRadius: '8px',
  '& .MuiTouchRipple-root *': {
    borderRadius: '8px !important',
  },
});
